import React from 'react'

const Login = () => {
    return (
        <>
            <div className='centerAlign mt10'>Login</div>
        </>
    )
}

export default Login;